var App = App || {};

App.SolutionsFinder = (function ($) {
    'use strict';

    function init() {
        const component = $(".solutions-finder:not(.condensed)");
        component.each(function () {
            const carousel = component.find(".splide");

            new Splide(carousel[0], {
                mediaQuery: 'min',
                arrows: true,
                pagination: false,
                type: 'slide',
                perMove: 1,
                focus: 1,
                start: 1,
                snap:false,
                gap: '1rem',
                rewind: false,
                slideFocus: false,
                updateOnMove: false,
                keyboard:true,
                cloneStatus: false,
                trimSpace: false,
                breakpoints: {
                    792: {
                        destroy:true,
                    },
                }
            }).mount();

        });

 
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.SolutionsFinder.init();
});